import { useEffect } from 'react';

// Publication runs in the background after the retry endpoint returns.
export default function usePublicationPolling({ id, status, request, setData, setError }) {
  useEffect(() => {
    if (!['queued', 'publishing', 'retry'].includes(status)) return undefined;
    let live = true;
    let timer;
    const poll = async () => {
      try {
        const data = await request(`/predictions/${id}`);
        if (!live) return;
        setData(data);
        setError('');
        if (!['queued', 'publishing', 'retry'].includes(data.publication?.status)) return;
      } catch (e) {
        if (!live) return;
        setError(e.message);
      }
      timer = setTimeout(poll, 3000);
    };
    timer = setTimeout(poll, 3000);
    return () => {
      live = false;
      clearTimeout(timer);
    };
  }, [id, status, request, setData, setError]);
}
